import { api } from './index';
import { Methods } from './interfaces';

const { POST, GET } = Methods;

export const listSubscriptions = () => {
  return api<void, any>({
    method: GET,
    route: '/subscription/all',
  });
};

export const listUserSubscriptions = () => {
  return api<void, any>({
    method: GET,
    route: '/subscription/user',
  });
};

export const cancelSubscription = (subId: string) => {
  return api<void, any>({
    method: POST,
    route: `/subscription/${subId}/cancel`,
  });
};

export const SubscriptionApi = {
  listSubscriptions,
  listUserSubscriptions,
  cancelSubscription,
};
